<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eJz4P5/tc-custom/9780547542140.jpg?1740715145864" alt="This image is the cover for the book Millstone"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Millstone
      </h1>
      <p class="bookDescription body article font2">
        <b>The story of an upper-middle-class unwed mother in 1960s London, from a novelist who is “often as meticulous as Jane Austen and as deadly as Evelyn Waugh” (<i>Los Angeles Times</i>).</b><br/>  <br/> In a newly swinging London, Rosamund Stacey indulges in a premarital sexual encounter—and soon thereafter finds herself pregnant. Despite her fierce independence and academic brilliance, Rosamund is in fact naïve and unworldly, and the choices before her are terrifying.<br/>  <br/> But in the perfection and helplessness of her baby she finds an unconditional love she has never known before—and as she navigates a situation still considered scandalous in her circles, she may discover that motherhood and independence need not be mutually exclusive.<br/>  <br/> From “one of Britain’s most dazzling writers,” the award-winning author of <i>The Dark Flood Rises</i>, <i>The Millstone</i> captures both a moment in history when women’s lives were changing dramatically and the timeless truths of the female experience (<i>The New York Times Book Review</i>).<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Drabble
      </h2>
      
      <p class="authorDescription body article">Margaret Drabble is the author of <I>The Sea Lady</I>, <I>The Seven Sisters</I>, <I>The Peppered Moth</I>, and <I>The Needle's Eye</I>, among other novels. For her contributions to contemporary English literature, she was made a Dame of the British Empire in 2008. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d0391ab